export function getCurrentUrl(pathname: string) {
  return pathname.split(/[?#]/)[0];
}

export function checkIsActive(pathname: string, url: string) {
  const current = getCurrentUrl(pathname)
  if (!current || !url) {
    return false
  }

  if (current === url) {
    return true
  }

  // Check if current path starts with url followed by a slash or query/hash
  // This prevents /theme-ai from matching /theme-ai-video
  if (current.startsWith(url + '/')) {
    return true
  }

  return false
}
